import { render, staticRenderFns } from "./TinderTab.vue?vue&type=template&id=1f84ac72&scoped=true"
import script from "./TinderTab.vue?vue&type=script&lang=js"
export * from "./TinderTab.vue?vue&type=script&lang=js"
import style0 from "./TinderTab.vue?vue&type=style&index=0&id=1f84ac72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f84ac72",
  null
  
)

export default component.exports